export const locale = {
    lang: 'es',
    data: {
        MONDAY_SHORT: 'Lun',
        TUESDAY_SHORT: 'Mar',
        WEDNESDAY_SHORT: 'Mie',
        THURSDAY_SHORT: 'Jue',
        FRIDAY_SHORT: 'Vie',
        HISTORY: {
            MEDIC_HISTORY: 'Historia completa',
            EVO_NOTE: 'Nota evolutiva',
            PENDING: 'Pendiente',
            RESCHEDULE: 'Reagendar',
        },
        MONTH: {
            JANUARY: 'Enero',
            FREBRUARY: 'Febrero',
            MARCH: 'Marzo',
            APRIL: 'Abril',
            MAY: 'Mayo',
            JUNE: 'Junio',
            JULY: 'Julio',
            AUGUST: 'Agosto',
            SEPTEMBER: 'Septiembre',
            OCTOBER: 'Octubre',
            NOVEMBER: 'Noviembre',
            DECEMBER: 'Diciembre',
        },
    },
};
